var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9613 2.3C4.54375 2.3 3.38548 3.28744 3.12715 4.56116L0.873047 4.10399C1.35082 1.74827 3.45976 0 5.9613 0C8.80519 0 11.1501 2.26568 11.1501 5.10876C11.1501 7.55731 9.41072 9.5777 7.1113 10.0912V11.15H4.8113V9.11753C4.8113 8.44476 5.35594 7.92497 5.99779 7.91731C7.59768 7.8982 8.8501 6.62696 8.8501 5.10876C8.8501 3.57912 7.57855 2.3 5.9613 2.3ZM6.02675 10.2171C6.02625 10.2171 6.02575 10.2171 6.02526 10.2171L6.02524 10.2171C6.02574 10.2171 6.02625 10.2171 6.02675 10.2171Z",
    fill: "current"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.8501,
    y: 12.85,
    width: 2.3,
    height: 2.3,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.293257b0dcd62cccbcbfa26cd0a554db.svg";
export { ForwardRef as ReactComponent };